export const IMPORT_KEEPASS_DATA = 'IMPORT_KEEPASS_DATA';
export const ERROR_IMPORTING_DATA = 'ERROR_IMPORTING_DATA';
export const CLEAR_KEEPASS_DATA = 'CLEAR_KEEPASS_DATA';
export const EXPORT_KEEPASS_DATA = 'EXPORT_KEEPASS_DATA';